import React, { useMemo } from "react";

import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { socialNetworksLogos } from "root/utils/socialNetworks";

import ColorCheckbox from "../ColorCheckbox";
import LogoForCharts from "../LogoForCharts";
import Tooltip_ from "../Tooltip";

// import styles from "./index.module.scss";

// -----------------------------------------------------------------
const SocialNetworksCheckBoxes = ({
  showSocialNetworks = false,
  setShowSocialNetworks = () => {},
  existSocialNetworks = [],
  lastReportDate,
}) => {
  //
  const disabled = useMemo(() => !existSocialNetworks.length, [existSocialNetworks]);
  //
  return (
    <Box mb={1} position={"relative"} width={"100%"}>
      <Box display={"flex"} flexWrap={"wrap"} gap={"1rem"} alignItems={"center"}>
        <Typography variant="h5">Социальные сети</Typography>
        <Box display={"flex"} flexWrap={"wrap"} gap={".5rem"} alignItems={"center"}>
          <Tooltip_
            title={
              disabled &&
              "Нет информации о публикациях в соц сетях по данному артикулу за выбранный период"
            }>
            <Box>
              <ColorCheckbox
                color="#cf3aa0"
                checked={!disabled && showSocialNetworks}
                disabled={disabled}
                onChange={e => setShowSocialNetworks(e.target.checked)}
              />
            </Box>
          </Tooltip_>
          {Object.keys(socialNetworksLogos).map(nameSN => {
            const isActive = existSocialNetworks.includes(nameSN);
            const currentImage = isActive
              ? socialNetworksLogos[nameSN].default
              : socialNetworksLogos[nameSN].disabled;
            return (
              <Tooltip_ key={nameSN} title={socialNetworksLogos[nameSN].tooltip}>
                <Box height={"16px"} sx={{ cursor: "pointer" }}>
                  <img
                    src={currentImage}
                    style={{
                      width: 16,
                      height: 16,
                      ...(!isActive ? { filter: "grayscale(1) opacity(0.5)" } : {}),
                    }}
                    alt={nameSN}
                  />
                </Box>
              </Tooltip_>
            );
          })}
        </Box>
      </Box>
      <LogoForCharts sx={{ position: "absolute", right: 0, bottom: 0 }} />
      {lastReportDate && (
        <Typography variant="subtitle2">
          дата последнего обновления соц. сетей: {format(new Date(lastReportDate), "dd.MM.yyyy")}
        </Typography>
      )}
    </Box>
  );
};

export default SocialNetworksCheckBoxes;
